import React from "react";
import { InputJson, printComponent } from "../../../nq-component";
import {
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import withRouter from "../../../withRouter";
import BaseFormPage from "../../../base/BaseFormPage";
import NavBar from "../../../components/navbar";
import FormFactory from "../../../components/FormFactory";
import EmployeeFormPresenter from "./EmployeeFormPresenter";
import ExitInterviewPDF from "../../../components/ExitInterviewPDF";

class EmployeeFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: { status: "Active" },
      advanced: false,
      exitInterview: {},
    };
    this.presenter = new EmployeeFormPresenter(
      this,
      upsertUseCase(),
      getObjectUseCase(),
      findObjectUseCase(),
      deleteObjectUseCase()
    );

    this.exitInterviewPDF = React.createRef();
  }

  getCollectionName() {
    return "employees";
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  async fetchExitInterview() {
    return this.presenter.getExitInterview();
  }

  async printExitForm() {
    await this.fetchExitInterview();
    printComponent(this.exitInterviewPDF.current);
  }

  render() {
    const { object, advanced, exitInterview } = this.state;
    const user = this.getCurrentUser();
    const params = this.getParams();
    console.log(params);
    const schema = this.getSchema(this.getCollectionName());
    delete schema.fields.lastPayDate;
    delete schema.fields.onBoardRemarks;
    delete schema.fields.remarks;
    delete schema.fields.termsAgreed;
    delete schema.fields.signature;
    delete schema.fields.orientationDate;
    delete schema.fields.deploymentType;
    delete schema.fields.endDate;
    delete schema.fields.quitClaim;
    delete schema.fields.exit_interview;

    console.log(schema);
    if (!schema) return <h1>no schema</h1>;
    const label =
      this.getObjectId() === undefined
        ? "Add New "
        : params?.name
        ? "View "
        : "Edit ";

    const schemaExitForm = this.getSchema("exit_interview");

    console.warn("object", object);
    return (
      <>
        <div className="d-none">
          <div ref={this.exitInterviewPDF}>
            <ExitInterviewPDF
              object={exitInterview}
              schema={schemaExitForm}
              employee={object}
            />
          </div>
        </div>
        <NavBar user={user} />
        <div className="overflow-auto">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center p-3">
                <h1
                  className="fw-bold text-capitalize mb-0"
                  style={{ color: "#d18237" }}
                >
                  <i
                    className="bi bi-arrow-left me-2"
                    onClick={this.onClickBack.bind(this)}
                  ></i>
                  {label + (schema.label || this.getCollectionName())}
                </h1>

                <div className="d-flex gap-2">
                  {object?.exit_interview && (
                    <button
                      className="btn text-white"
                      style={{ backgroundColor: "#3174ad" }}
                      onClick={this.printExitForm.bind(this)}
                    >
                      <i className="bi bi-file-earmark-text me-2 fw-bold" />
                      Exit Interview Form
                    </button>
                  )}

                  {!params.name && (
                    <button
                      className="btn ms-auto text-white"
                      style={{ backgroundColor: "#e09552" }}
                      onClick={this.onSubmitForm.bind(this)}
                      disabled={params.name}
                    >
                      Submit
                    </button>
                  )}
                </div>
              </div>

              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form onSubmit={this.onSubmitForm.bind(this)}>
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChangeObject.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <FormFactory
                        schema={schema}
                        object={object}
                        onChange={this.onChange.bind(this)}
                        disabled={params.name}
                      />
                    )}
                  </div>
                  {/* <div className="mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary fs-sm me-3"
                    >
                      <i className="bi bi-file-earmark-check me-2"></i>SAVE
                    </button>
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div> */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(EmployeeFormPage);
